import {TastingSetupFactory} from './types';

import swa20 from './swa20';

const supportedSetups: TastingSetupFactory = {swa20};

export default supportedSetups;
